<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>软件对接列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
          <el-form
            size="mini"
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >

            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="所属省份"  clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="客商名称" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="编号" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="类型" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.grade_id"
                style="width: 180px;"
                placeholder="请选择类别"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">

                </el-option>
              </el-select>

            </el-form-item>
            <el-form-item>
            <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
            </el-form-item>

          </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        border
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >

        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="名称"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="编码"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.sn}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="联系人"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.cont_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系电话"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.mobile}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属区域"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{scope.row.province?scope.row.province.region_name:''}}</span>
            <span>{{scope.row.city?scope.row.city.region_name:''}}</span>
            <span>{{scope.row.district?scope.row.district.region_name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="地址"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="260">
          <template slot-scope="scope">
            <el-button  type="text" size="mini" @click="goInfo(scope.row)">查看</el-button>
            <el-button @click="goEdit(scope.row)"  type="text" size="mini">修改</el-button>
            <el-button type="text" size="mini" @click="goZcPay(scope.row)">支付参数</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->


    <ePosList
      :formData="formData"
      :visible="visible"
      :title="title"
      :closeForm="closeForm"
    />

    <eShop
      :formData="formData1"
      :visible="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />

    <ePos
      :formData="formData2"
      :visible="visible2"
      :title="title2"
      :closeForm="closeForm2"
    />
    <eShopInfo
      :formData="formData3"
      :visible="visible3"
      :title="title3"
      :closeForm="closeForm3"
    />
  </div>
</template>

<script>
  import eShopInfo from "./components/eShopInfo.vue";
  import ePos from "../common/ePOS.vue";
  import eShop from "./components/eShop.vue";
  import ePosList from "./components/ePostList.vue";
  import moment from 'moment'     //日期时间转换

  export default {
    name: "proxyShopList",
    components: {
      ePosList,eShop,ePos,eShopInfo
    },
    props: {},
    data() {
      return {
        formData3: {},
        title3: "",
        visible3: false,

        formData2: {},
        title2: "",
        visible2: false,

        formData:{},
        visible:false,
        title:'',

        formData1:{},
        visible1:false,
        title1:'',

        gradeList:[],
        // 搜索
        searchForm: {
          name: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入文章标题", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,

        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {

      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {
      goZcPay(row){
        this.title2="支付参数——"+row.name;
        console.log('0000----1111-----')
        this.visible2=true;
        this.formData2=row;
        this.formData2.appid=row.appid?row.appid:"";
        this.formData2.api_path=row.api_path?row.api_path:"https://api.zhichipay.com/";
        this.formData2.public_key=row.public_key?row.public_key:"MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtCov1WUC7mLWe5ERQ80MPnWxutNoARtQEGrsBWiXIdM+T1P/PArBgeI0MkMR0RGSVjrK5Rqsn9sOrqUBeuJGO1thpQQpPPI2izdxUwoF/fPISyiIedtaTOMEBsQ8wfTQXOQ6sScJJgBeNHukSGXB8KnCJsRPvTEz+IdT6iZ8mY1w/FONLruuwFNzKi72PM1cfNEN35/iGLQtHh7Xs83W6/5HX+8pn6S3sXmMBKG7M0TTrXn8WaTk7EYNtSKYRSMWlNkjStitUYUkSTDLP3WoPKUVe5YnBoGXQxKPUijAZjL7MhOhpwX8efEYr+l9nFAB4z0OqkFpQFEEgvEsjkbt+QIDAQAB";
        this.formData2.private_key=row.private_key?row.private_key:"MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC0Ki/VZQLuYtZ7kRFDzQw+dbG602gBG1AQauwFaJch0z5PU/88CsGB4jQyQxHREZJWOsrlGqyf2w6upQF64kY7W2GlBCk88jaLN3FTCgX988hLKIh521pM4wQGxDzB9NBc5DqxJwkmAF40e6RIZcHwqcImxE+9MTP4h1PqJnyZjXD8U40uu67AU3MqLvY8zVx80Q3fn+IYtC0eHtezzdbr/kdf7ymfpLexeYwEobszRNOtefxZpOTsRg21IphFIxaU2SNK2K1RhSRJMMs/dag8pRV7licGgZdDEo9SKMBmMvsyE6GnBfx58Riv6X2cUAHjPQ6qQWlAUQSC8SyORu35AgMBAAECggEAAQaAcTF6+8paOCfSNlWTbUOUOGD9pYv3P7CsGTfILGwcXa03tarGASw9ac/R6SO1doItJ3Koatx/T+UmhgGFrs7NVngYl/007EPrhDJ5aEGb8TmQ1Ui3Udq06ijxw5TWHsE5yEpVlf7IinntrG/P08PTlA7n+UavagmzI5EGgoU2GuCxURS53PqpbBnqNZp7WdgMQszswhZWemFuWnKgUOfNWVmd7iNnLOlacpFOchMjJAwuSeXLAM82E73J5RRj163WY33DGC+3GUX11z2aldKoi9Bg/TztSuyGBmsnYmhvE07AeVXVExAsCVnlOptmyxha5bHT/7ciABLynvl70QKBgQDvcnOsrqN6d33mpEngHP71sukqAC6qk/Kxyrb0qIwndfyfdmRj7m5nQvp96HbgRxOp70c4nZZLYlR3fX2JFbZXhyLrYElgS9Otx+kcJ4Y5FMfHQ1chw45j3c12TaW4SLE+rYZDcRDnP6BFV7/kkmv3PSb3X0YhP/uVKfDtLg3clQKBgQDAnppsqp4Tiwwt+PdncQE4lMju9Ub3ro5OOLOQxJQ07ghYMaE6iS0tNop56uu0OgiFlXv4hydgKQZBJTTAWRhhqmn9WlPf7n0bOzvwKBobIYUz0KmJTJ27ZAX9mrHWUGtxMv9yvaPQqrRGScvb9C6TksRsXQO6PrL4eJuRGiVO1QKBgH2VBV4X6d2dNgb1O1mzW3T5dJh2qAMGvU7KBtKiY39+vhPUQCq5LmYyFrZaaZ6PKJ0DxdLHs7+tvqc8xc5T+OJHGeVhBpreqhKGupftktP1NiIoC1bF/bQa7FuTtcrFNVCuKbDNaBQgpqo3r4jt0npFNF6hNWLS79v3t0ht0w9RAoGAGl3bj6JvTweKnERnQV6jpyYety8WDtNzIVv7oIZ4LyKiO8hXZJbgez7rB7NTnnEPN5H1zVha2HvlIkfAh8/qWXwlVAvoTU/tCiw6kS48HJijDiuy+Vtmf/86HrPtQgPyISW09/Tjlq23TaPOZwZu1b6Saq700qrAfuiritpEXx0CgYBS8DDlxxH3kcBlU9Y0SZGvG91cN95A2Lfy9d0OtHIwwsnJGO6/YHgZDKCANFNOSVz1JFI+kVGu/dVihRMu73oV8SvghccLaUnbYJYkdsZlRl2XB3l/XA91m0DPTC4IOQXeGcW5jwDzyrWeP3KgVkz4gcwrBor9XjB0UIfTaelm9w==";
      },
      clearValue(){
        this.value=null;
      },

      goPos(row){
        this.formData = row;
        this.title = 'POS管理('+row.name+")";
        this.visible = true;
      },
      closeForm() {
        this.formData = {};
        this.title = "";
        this.visible = false;
      },
      closeForm1() {
        this.formData1 = {};
        this.title1 = "";
        this.visible1 = false;

        this.pageNum=1;
        this.tableLoadData=[];
        this.DataList();
      },
      closeForm2() {
        console.log('9999------')
         this.formData2 = {};
        this.title2 = "";
        this.visible2 = false;
       this.pageNum=1;
        this.DataList();
      },
      closeForm3() {
        this.formData3 = {};
        this.title3 = "";
        this.visible3 = false;
      },
      goInfo(row){
        this.formData3 = row;
        this.title3 = "软件对接详情";
        this.visible3 = true;
      },

      goEdit(row){
        this.formData1 = row;
        this.formData1.company_user_real_name=row.companyuser?row.companyuser.real_name:'';
        this.formData1.proxy_name=row.proxy?row.proxy.username:'';

        this.title1 = "门店编辑";
        this.visible1 = true;
      },

      goCategory(){
        this.$router.push('/newsCategory')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        let _this=this;
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          proxy_id:sessionStorage.getItem('proxy_id'),
          pageNum:_this.pageNum,
          pageSize:_this.pageSize,
        }
        this.$axios.payShopListByPayP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total=res.data.total;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push('/proxyForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      searchSubmit() {
         this.pageNum=1;
         this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
